"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceInfoTab = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const reactstrap_1 = require("reactstrap");
const DeviceInfoTab = ({ pgnData, info }) => {
    // Helper function to get field name from PGN definition
    const getFieldDisplayName = (pgnInfo, fieldId) => {
        try {
            // Get the definition from the current pgnData
            const definition = pgnInfo.getDefinition();
            if (definition && definition.Fields) {
                // Look for a field with matching ID or Name
                const fieldDef = definition.Fields.find((f) => f.Id === fieldId || f.Name === fieldId);
                if (fieldDef && fieldDef.Name) {
                    return fieldDef.Name;
                }
            }
        }
        catch (error) {
            // If anything fails, fall back to formatting the field ID
            console.error('Error getting field display name:', error);
        }
        // Fallback: format the field ID nicely
        return 'unknon'; /*fieldId
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, (str) => str.toUpperCase())
          .trim()*/
    };
    const tabHeader = () => {
        return ((0, jsx_runtime_1.jsxs)("small", { children: [(0, jsx_runtime_1.jsx)("strong", { children: "PGN:" }), " ", pgnData.pgn, " |", (0, jsx_runtime_1.jsx)("strong", { children: " Source:" }), " ", pgnData.src, " |", (0, jsx_runtime_1.jsx)("strong", { children: " Destination:" }), ' ', pgnData.dst, (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("strong", { children: "Description:" }), " ", pgnData.description || 'N/A'] }));
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(reactstrap_1.CardHeader, { children: tabHeader() }), (0, jsx_runtime_1.jsx)("div", { className: "p-3", children: info[pgnData.src]?.info ? ((0, jsx_runtime_1.jsx)("div", { children: Object.entries(info[pgnData.src].info).map(([pgnNumber, pgnInfo]) => ((0, jsx_runtime_1.jsxs)(reactstrap_1.Card, { className: "mb-3", style: { border: '1px solid #e0e0e0' }, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.CardHeader, { style: { backgroundColor: '#f8f9fa', padding: '10px 15px' }, children: (0, jsx_runtime_1.jsxs)("h6", { className: "mb-0", style: { color: '#495057' }, children: ["PGN ", pgnNumber, ": ", pgnInfo.description || 'Unknown'] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.CardBody, { style: { padding: '15px' }, children: (0, jsx_runtime_1.jsx)("div", { className: "row", children: Object.entries(pgnInfo.fields)
                                        .filter(([key]) => key !== 'description')
                                        .map(([key, value]) => ((0, jsx_runtime_1.jsx)("div", { className: "col-12 mb-2", children: (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'flex-start' }, children: [(0, jsx_runtime_1.jsxs)("strong", { style: {
                                                        minWidth: '200px',
                                                        marginRight: '15px',
                                                        color: '#6c757d',
                                                        textTransform: 'capitalize',
                                                        flexShrink: 0,
                                                    }, children: [getFieldDisplayName(pgnInfo, key), ":"] }), (0, jsx_runtime_1.jsx)("span", { style: {
                                                        wordBreak: 'break-word',
                                                        color: '#212529',
                                                        flex: 1,
                                                    }, children: value })] }) }, key))) }) })] }, pgnNumber))) })) : ((0, jsx_runtime_1.jsx)("div", { style: {
                        textAlign: 'center',
                        color: '#6c757d',
                        padding: '40px',
                        fontStyle: 'italic',
                    }, children: "No device information available for this source" })) })] }));
};
exports.DeviceInfoTab = DeviceInfoTab;
